"use strict";

;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);
  var initialized = false;

  /**
   * Do stuff on the page load
   */
  function onPageLoad() {
    var _document$querySelect;
    if (initialized) {
      return;
    }
    initialized = true;
    (_document$querySelect = document.querySelector('#load-related')) === null || _document$querySelect === void 0 || _document$querySelect.addEventListener('click', onClick);
  }
  function onClick() {
    var _document$querySelect2;
    var button = document.querySelector('#load-related');
    if (!button) {
      return;
    }
    var additionalRelated = document.querySelector('.additional-related');

    // Remove load button when no more additional related blocks
    if (!additionalRelated) {
      button.remove();
      return;
    }

    // Remove _nativeAd block on the 2+ pages to make new videos align
    // otherwise it will be 1 video with 3 empty slots on the 5th row
    (_document$querySelect2 = document.querySelector('._nativeAd')) === null || _document$querySelect2 === void 0 || (_document$querySelect2 = _document$querySelect2.parentElement) === null || _document$querySelect2 === void 0 || _document$querySelect2.remove();
    additionalRelated.classList.remove('additional-related');
    additionalRelated.classList.remove('d-none');
    document.dispatchEvent(new Event('flix:additional-related'));

    // Remove load button when it was the last relation block
    if (!document.querySelector('.additional-related')) {
      button.remove();
      return;
    }
  }
})();